export default "__VITE_ASSET__4dacaace__"